import { IonPage, IonContent, IonButton, IonRange } from '@ionic/react'
import InitialConfigHeader from '../header'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setInitialConfigProperty } from '../../../redux/reducer/initialConfigSlice'
import '../InitialConfiguration.min.css'
import measures from '../../../settings/measuresConfig'
import { useHistory } from 'react-router'

const HeightPage = ({ step, totalSteps }) => {
	const history = useHistory()
	const measureIndex = measures.findIndex(
		(measure) => measure.value === 'height'
	)
	const [isLoading, setIsLoading] = useState(false)
	const height =
		useSelector((state) => state.initialConfig.height) ||
		measures[measureIndex].initialValue
	const dispatch = useDispatch()

	const updateInput = (e) => {
		dispatch(setInitialConfigProperty({ key: 'height', value: e.detail.value }))
	}

	const handleSubmit = () => {
		setIsLoading(true)
		history.push(`/impostazioni-iniziali/${step + 1}`)
		setIsLoading(false)
	}

	const handleDecrease = () => {
		const newValue = height - measures[measureIndex].step
		dispatch(
			setInitialConfigProperty({
				key: 'height',
				value: Math.max(newValue, measures[measureIndex].min),
			})
		)
	}

	const handleIncrease = () => {
		const newValue = height + measures[measureIndex].step
		dispatch(
			setInitialConfigProperty({
				key: 'height',
				value: Math.min(newValue, measures[measureIndex].max),
			})
		)
	}

	return (
		<IonPage className="initial-configuration">
			<InitialConfigHeader
				step={step}
				totalSteps={totalSteps}
				isLoading={isLoading}
			/>

			<IonContent>
				<h1>Qual è la tua altezza?</h1>
				<h6>È fondamentale per stabilire il tuo peso forma</h6>
				<IonRange
					min={measures[measureIndex].min}
					max={measures[measureIndex].max}
					step={measures[measureIndex].step}
					pinFormatter={(value) =>
						value.toFixed(2).replace('.', ',') +
						' ' +
						measures[measureIndex].suffix
					}
					pin={true}
					className="measure-range"
					onIonChange={updateInput}
					value={height}
				/>
				<div className="measure-buttons">
					<IonButton
						shape="round"
						onClick={handleDecrease}
						disabled={isLoading}
						color="primary">
						-
					</IonButton>
					<IonButton
						shape="round"
						onClick={handleIncrease}
						disabled={isLoading}
						color="primary">
						+
					</IonButton>
				</div>
				<div className="buttons">
					<IonButton
						shape="round"
						onClick={handleSubmit}
						disabled={isLoading}
						color="primary"
						expand="full">
						Avanti
					</IonButton>
				</div>
			</IonContent>
		</IonPage>
	)
}

export default HeightPage
